import { defineComponent as _defineComponent } from 'vue'
import { computed, type PropType } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    icon: {
      type: String,
      default: null,
    },
    action: {
      type: String as PropType<'cta' | 'success' | 'error' | 'warning' | 'secondary'>,
      default: "cta",
    },
    type: {
      type: String as PropType<'filled' | 'outlined' | 'text'>,
      default: "filled",
    },
    size: {
      type: String as PropType<'small' | 'medium' | 'large'>,
      default: "medium",
    },
  },
  emits: ["click"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const cssVars = computed(
  () => {
    return {
      "--btn-border-color": `var(--token-button-color-${props.action}-${props.type}-default-border-color)`,
      "--btn-border-color-hover": `var(--token-button-color-${props.action}-${props.type}-hover-border-color)`,
      "--btn-border-color-active": `var(--token-button-color-${props.action}-${props.type}-active-border-color)`,

      "--btn-background": `var(--token-button-color-${props.action}-${props.type}-default-background-color)`,
      "--btn-background-hover": `var(--token-button-color-${props.action}-${props.type}-hover-background-color)`,
      "--btn-background-active": `var(--token-button-color-${props.action}-${props.type}-active-background-color)`,

      "--btn-text-color": `var(--token-button-color-${props.action}-${props.type}-default-text-color)`,
      "--btn-text-color-hover": `var(--token-button-color-${props.action}-${props.type}-hover-text-color)`,
      "--btn-text-color-active": `var(--token-button-color-${props.action}-${props.type}-active-text-color)`,

      "--btn-gap": `calc(var(--token-button-spacing-large-gap) * 1px)`,

          
      "--btn-padding": `calc(var(--token-button-spacing-${props.size}-padding-vertical) * 1px) calc(var(--token-button-spacing-${props.size}-padding-horizontal) * 1px)`,
      "--btn-padding-left": props.icon ? `calc(var(--token-button-spacing-${props.size}-padding-left-with-icon) * 1px)` : `calc(var(--token-button-spacing-${props.size}-padding-horizontal) * 1px)`,
    };
  }
);


const __returned__ = { props, cssVars }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})